import { BaseFragmentController } from 'src/app/View/BaseUI/BaseFragmentController';
import { ReserveConfirmDateFragmentComponent } from './ReserveConfirmDateFragmentComponent';

/**
 * ReserveConfirmFragmentController
 * 問診画面のコントローラー
 */
export class ReserveConfirmDateFragmentController extends BaseFragmentController {

	// 対となるView
	public combineView: ReserveConfirmDateFragmentComponent;
}
